<template>
    <div id="pro-cmaj-form">
        <sit-form-header
          class="pt-5 pb-5 sit-header w-100"
          :code="code"
          :loaded="loaded"
          :draft="draft">
        </sit-form-header>

        <div class="pro-main-container-bloc pt-5"
             :style="'background-color:' + backGroundColor + ';font-family:' + fontFamily">
            <div class="mx-auto col-11">
                <cmaj-form-error v-if="code !== null" :code="code"></cmaj-form-error>

                <div class="mt-12 mb-5 row" v-if="loaded && !displayThanks && code === null">
                    <div class="col-4 mt-3" id="cmaj-menu-container">
                        <cmaj-form-menu :tabulations="tabulations" :sit="sit"></cmaj-form-menu>
                    </div>
                    <div class="cmaj-form col-12 col-xl-8">

                        <cmaj-form-tabulations :tabulations="tabulations"></cmaj-form-tabulations>
                    </div>
                </div>

                <div v-else-if="code === null && !displayThanks" class="mt-5 mb-5 d-flex">
                    <content-placeholders class="cmaj-menu" style="margin-right: 150px">
                        <content-placeholders-text style="width: 300px; height: 51px"></content-placeholders-text>
                        <content-placeholders-heading style="width: 300px; height: 51px" />
                    </content-placeholders>

                    <content-placeholders class="w-100">
                        <content-placeholders-img style="height: 250px"></content-placeholders-img>
                        <content-placeholders-text></content-placeholders-text>

                        <content-placeholders-heading style="width: 300px; margin-top: 40px">
                        </content-placeholders-heading>
                        <content-placeholders-img
                          style="height: 200px; margin-top: 40px"></content-placeholders-img>
                    </content-placeholders>
                </div>

                <help-modal :referent="referent" v-if="!displayThanks && referent !== null && !sit"></help-modal>

                <copyright-modal v-if="code === null"></copyright-modal>

                <opening-period-modal v-if="loaded && code === null"></opening-period-modal>

                <price-period-modal v-if="loaded && code === null"></price-period-modal>

                <form-thanks :organism="organism" :logo="logo"></form-thanks>
            </div>
        </div>

        <!-- Retour en haut -->
        <div id="up-scroll" @click="scrollTop">
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                            <v-icon class="white--text">keyboard_arrow_up</v-icon>
                        </span>
                </template>
                <span>Retour en haut</span>
            </v-tooltip>
        </div>

    </div>
</template>

<script>
import CmajFormTabulations from "../CmajFormTabulations.vue"
import HelpModal from "../modals/HelpModal.vue"
import CopyrightModal from "../modals/CopyrightModal.vue"
import OpeningPeriodModal from "../modals/OpeningPeriodModal.vue"
import PricePeriodModal from "../modals/PricePeriodModal.vue"
import CmajFormError from "../CmajFormError.vue"
import CmajFormMenu from "../CmajFormMenu.vue"
import SitFormHeader from "./SitFormHeader.vue"

import { mapState } from "vuex"
import FormThanks from "../FormThanks.vue"

export default {
    name: "SitFormContainer",
    props: ["code", "loaded", "logo", "noHeader", "organism", "referent", "sit", "draft"],
    components: {
        FormThanks,
        CmajFormMenu,
        CmajFormError,
        PricePeriodModal,
        OpeningPeriodModal,
        CopyrightModal,
        HelpModal,
        CmajFormTabulations,
        SitFormHeader,
    },
    methods: {
        scrollTop() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
        },
    },
    computed: {
        ...mapState("webFormStyle", ["fontFamily", "backGroundColor", "primaryColor"]),
        ...mapState("web_form", ["displayThanks", "tabulations", "readOnly"]),
    },
}
</script>

